import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalRequestTigoSaleOrderPage } from './modal-request-tigo-sale-order.page';

const routes: Routes = [
  {
    path: '',
    component: ModalRequestTigoSaleOrderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalRequestTigoSaleOrderPageRoutingModule {}
